import React, { createContext } from "react";

const SocketContext = createContext(null);

export default SocketContext;